require('./data-hierarchy-spot/component-a-data-hierarchy.js');
require('./data-hierarchy-spot/component-data-hierarchy-spot-ui-elements.js');